"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateHelpers = void 0;
class TemplateHelpers {
    /**
     * transform pattern:
     * methodName(...params) {} to methodName: (...params) => {}
     * @param fnName
     * @param fnStr
     * @returns
     */
    static sanitizeFn(fnName, fn) {
        let fnStr = fn.toString();
        if (fnName != fn.name) {
            let fnOffset = fnStr.indexOf("(");
            fnStr = fnStr.substring(fnOffset);
            fnOffset = fnStr.indexOf(")");
            fnStr = fnStr.substring(0, fnOffset + 1) + " =>" + fnStr.substring(fnOffset + 1);
        }
        return `${fnName}: ${fnStr}`;
    }
    static merge(prefix, values, suffix) {
        let result = prefix;
        for (let i = 0; i < values.length; i++) {
            result = `${result}  ${values[i]}`;
            if (i < values.length - 1) {
                result = result + ",";
            }
            result = result + "\r\n";
        }
        return result + suffix;
    }
    static toString(helpers) {
        const methods = [];
        Object.keys(helpers).forEach(k => {
            let fn = helpers[k];
            let sanitizedFn = TemplateHelpers.sanitizeFn(k, fn);
            methods.push(sanitizedFn);
        });
        return TemplateHelpers.merge("const helpers = {\r\n", methods, "}");
    }
    static build(generator) {
        const defaulHelpers = {
            defaultVisibilityOrder: generator.getDefaultVisibilityOrder,
            capitalize: (str) => { return str.replace(/\w/, c => c.toUpperCase()); },
            getArrayDefault: (str) => {
                var _a, _b;
                let result = str;
                if (str === null || str === void 0 ? void 0 : str.match("new Array")) {
                    result = (_b = (_a = str.match(/\((.*?)\)/g)) === null || _a === void 0 ? void 0 : _a.toString().replace("(", "").replace(")", "")) !== null && _b !== void 0 ? _b : str;
                }
                else if ((str === null || str === void 0 ? void 0 : str.includes("[")) && str.includes("]")) {
                    result = str.replace("[", "").replace("]", "");
                }
                return result;
            },
            camelize: (str) => { return str[0].toLowerCase() + str.substring(1); },
            toUpperCase: (str) => { return str.toUpperCase(); },
            toLowerCase: (str) => { return str.toLowerCase(); },
            sanitize: (str, replaceChar) => { return str.replace(/[^a-zA-Z0-9_ ]/g, replaceChar); },
            orderBy: (e, f, s) => {
                return e.sort((a, b) => {
                    let indexA = s.indexOf(a[f]);
                    let indexB = s.indexOf(b[f]);
                    return indexA - indexB;
                });
            },
            splitBlock: (...values) => {
                if (values.every(v => v && v.length)) {
                    return "\n";
                }
                return "";
            },
            ifAny: (...values) => {
                if (values.find(v => v && v.length)) {
                    return true;
                }
                return false;
            }
        };
        return Object.assign(Object.assign({}, defaulHelpers), generator.getCustomHelpers(defaulHelpers));
    }
}
exports.TemplateHelpers = TemplateHelpers;
